// extracted by mini-css-extract-plugin
export default {"WeekEditor":"WeekEditor_WeekEditor__4W4h0","WeekEditorMobile":"WeekEditor_WeekEditorMobile__i6-kP"};